export default __webpack_public_path__ + "static/doddle-4c4c4e8016691887246ba0b83f8caaed.svg";